export default __webpack_public_path__ + "static/media/create-group.d29855e4.PNG";